import { render, staticRenderFns } from "./ListadoItem.vue?vue&type=template&id=27c1a8c2&scoped=true"
import script from "./ListadoItem.vue?vue&type=script&lang=js"
export * from "./ListadoItem.vue?vue&type=script&lang=js"
import style0 from "./ListadoItem.vue?vue&type=style&index=0&id=27c1a8c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c1a8c2",
  null
  
)

export default component.exports